import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  page: {
    marginTop: 30,
    paddingBottom: 60
  },
  platformSelect: {
    width: 200
  }
})

export default useStyles
